var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-retry-box" },
    [
      _c("div", { staticClass: "title center" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("login.retry.title")) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", [_vm._v(_vm._s(_vm.$t("login.retry.text1")))]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.$t("login.retry.text2")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "caution-box" }, [
        _c("div", { staticClass: "caution" }, [
          _vm._v(_vm._s(_vm.$t("login.retry.caution1"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "wrong-guide" }, [
            _vm._v(_vm._s(_vm.$t("login.retry.wrongGuide"))),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/images/page/photo_ex_wrong_02.png"),
              alt: "",
            },
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/images/page/photo_ex_wrong_03.png"),
              alt: "",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [_vm._v(_vm._s(_vm.$t("login.retry.text3")))]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.$t("login.retry.text4")))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "caution-box" }, [
        _c("div", { staticClass: "caution" }, [
          _vm._v(_vm._s(_vm.$t("login.retry.caution2"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "wrong-guide" }, [
            _vm._v(_vm._s(_vm.$t("login.retry.wrongGuide"))),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/images/page/photo_ex_wrong_06.png"),
              alt: "",
            },
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/images/page/photo_ex_wrong_04.png"),
              alt: "",
            },
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/images/page/photo_ex_wrong_07.png"),
              alt: "",
            },
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/images/page/photo_ex_wrong_08.png"),
              alt: "",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [_vm._v(_vm._s(_vm.$t("login.retry.text5")))]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.$t("login.retry.text6")))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-box center gap-10" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-dark",
            attrs: { type: "button" },
            on: {
              click: () => {
                _vm.$emit("retryLogin")
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("login.retry.button")) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.loginFailAction === "reRegister"
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg btn-green",
                attrs: { type: "button" },
                on: { click: _vm.retryRegister },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("login.retry.retryFaceButton")) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("i18n", {
        staticClass: "contract",
        attrs: { tag: "div", path: _vm.contractPath },
        scopedSlots: _vm._u([
          {
            key: "contract",
            fn: function () {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.contractLink,
                      target: _vm.contractTarget,
                    },
                  },
                  [_vm._v(_vm._s(_vm.contractLinkText))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }